import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EncrDecrService } from '../../services/encr-decr.service';
import {environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient,
    private EncDecrService: EncrDecrService) { }

    getDateOverview(data) {
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'admin/dateOverview', data,{headers: headers_object}).toPromise()
    }

    getMostViewedEvents() {
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'admin/mostViewedEvents', {fitler:"current"},{headers: headers_object}).toPromise()
    }

    getDashboard() {
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'admin/dashboard', {},{headers: headers_object}).toPromise()
    }

    getVisitorsOverview(data) {
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'admin/visitorOverview', {filter: data},{headers: headers_object}).toPromise()
    }
}
